@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.container {
    text-align: center;
}

.heading {
    font-size: 2.75rem;
    font-style: italic;
}

.subheading {
    font-size: 1.875rem;
}

.form {
    width: 50%;
    margin: 40px auto 20px;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        width: 90%;
    }

    label {
        text-align: left;
    }
}

.emailField {
    margin-bottom: 20px;
}

.submit {
    composes: button from "../../styles/buttons.module.scss";
}
